var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPayee = function SvgPayee(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64963 19C5.59949 19.0001 5.55021 18.9927 5.50217 18.9814C5.38747 18.9551 5.27809 18.8988 5.1887 18.8096C5.0619 18.6828 4.99839 18.516 4.99827 18.3496V7.44922C4.99836 7.09044 5.2899 6.80001 5.64866 6.7998C6.00747 6.79994 6.29798 7.0904 6.29807 7.44922V16.7803L17.8879 5.19043C18.1418 4.93659 18.554 4.93659 18.8078 5.19043C19.0613 5.4443 19.0616 5.85662 18.8078 6.11035L7.22092 17.6973L16.5266 17.6787C16.8854 17.6782 17.1772 17.9683 17.178 18.3271C17.1784 18.6859 16.8874 18.9778 16.5285 18.9785L5.64963 19Z",
    fill: "#18191B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPayee);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "payee.56d2da3b01436a4b6762e7b4b80e7068.svg";